import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { SettingsPage } from './settings';
import { LangModule } from 'src/app/modules/lang/lang.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    LangModule
  ],
  declarations: [SettingsPage],
  entryComponents: [SettingsPage]
})
export class SettingsPageModule { }
